import React, { useEffect, useState, useContext } from "react";
import AuthContext, { AuthProvider } from '../context/AuthContext';

const MySubmissions = () => {
  const [submissions, setSubmissions] = useState([]);
  const [loading, setLoading] = useState(true);

  let { user } = useContext(AuthContext);

  useEffect(() => {
    fetchSubmissions();
  }, []);

  const fetchSubmissions = async () => {
    try {
      // console.log(user.username)
      // const api_link = `http://localhost:8000/check-submissions/${user.username}`;
      const api_link = `https://api.mba-gris.stgafrica.org/check-submissions/${user.username}`;
      const response = await fetch(api_link);
      const data = await response.json();
      setSubmissions(data);
    } catch (error) {
      console.error("Error fetching submissions", error);
    } finally {
      setLoading(false);
    }
  };

  // Summary calculation
  const total = submissions.length;
  const males = submissions.filter((i) => i.sex?.toLowerCase() === "male").length;
  const females = submissions.filter((i) => i.sex?.toLowerCase() === "female").length;
  const pwds = submissions.filter((i) => i.pwd_status === true).length;

  const femalePercentage = total > 0 ? ((females / total) * 100).toFixed(1) : 0;
  const pwdPercentage = total > 0 ? ((pwds / total) * 100).toFixed(1) : 0;

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>My Submissions</h2>

      {loading ? (
        <div style={styles.loading}>Loading...</div>
      ) : (
        <>
          <div style={styles.summaryBox}>
            <h3 style={styles.summaryTitle}>Submission Summary</h3>
            <table style={styles.table}>
              <tbody>
                <tr>
                  <td>Total Submissions:</td>
                  <td>{total}</td>
                </tr>
                <tr>
                  <td>Total Males:</td>
                  <td>{males}</td>
                </tr>
                <tr>
                  <td>Total Females:</td>
                  <td>{females}</td>
                </tr>
                <tr>
                  <td>Female %:</td>
                  <td>{femalePercentage}%</td>
                </tr>
                <tr>
                  <td>PWD %:</td>
                  <td>{pwdPercentage}%</td>
                </tr>
              </tbody>
            </table>
          </div>

          {submissions.length === 0 ? (
            <p style={styles.noSubmissions}>No submissions yet.</p>
          ) : (
            submissions.map((innovator, index) => (
              <div key={innovator.id} style={styles.card}>
                <h3 style={styles.name}>
                  {index + 1}. {innovator.first_name} {innovator.last_name} {innovator.other_name}
                </h3>

                <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'start', gap: '16px' }}>
                  <p style={styles.location}>
                    <b>District: </b> 
                    {innovator.district
                      ?.split('_')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                      .join(' ')}
                  </p>

                  {/* <p style={styles.location}>{innovator.sex}</p> */}
                  <p style={styles.location}><b>Gender: </b>{innovator.sex?.charAt(0).toUpperCase() + innovator.sex?.slice(1).toLowerCase()}</p>
                  <p style={styles.location}><b>Community: </b>{innovator?.community}</p>

                </div>

                <div style={{ display: 'flex', justifyContent: 'left', alignItems: 'start', gap: '16px' }}>
                  <p style={styles.location}><b>Age:</b> {innovator.age}</p>
                </div>
                  <p style={styles.location}><b>Solution:</b> {innovator.solution}</p>
                  

                <div style={styles.mediaGrid}>
                  {innovator.multimedia.map((file, idx) => {
                    const url = `https://api.mba-gris.stgafrica.org/multimedia/${file}`;
                    const extension = file.split('.').pop().toLowerCase();
                    const isVideo = ['mp4', 'webm', 'ogg'].includes(extension);

                    return (
                      <div key={idx} style={styles.mediaItem}>
                        {isVideo ? (
                          <video controls style={styles.media}>
                            <source src={url} type={`video/${extension}`} />
                            Your browser does not support the video tag.
                          </video>
                        ) : (
                          <img src={url} alt={`Media ${idx + 1}`} style={styles.media} />
                        )}
                      </div>
                    );
                  })}
                </div>

                  <p style={styles.date}>
                    Submitted on: {new Date(innovator.date_time).toLocaleDateString()}
                  </p>

              </div>
            ))
          )}
        </>
      )}
    </div>
  );
};

// 👇 Internal CSS object
const styles = {
  container: {
    padding: "24px",
    maxWidth: "1000px",
    margin: "0 auto",
    fontFamily: "Arial, sans-serif",
  },
  header: {
    fontSize: "28px",
    fontWeight: "bold",
    marginBottom: "20px",
  },
  loading: {
    padding: "20px",
    textAlign: "center",
    fontSize: "18px",
  },
  noSubmissions: {
    fontStyle: "italic",
    color: "#666",
  },
  summaryBox: {
    marginBottom: "24px",
    padding: "16px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    backgroundColor: "#f9f9f9",
  },
  summaryTitle: {
    marginBottom: "10px",
    fontSize: "20px",
    fontWeight: "bold",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  card: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    padding: "16px",
    marginBottom: "24px",
    borderRadius: "6px",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
  },
  name: {
    fontSize: "22px",
    marginBottom: "4px",
  },
  location: {
    fontSize: "14px",
    color: "#555",
  },
  date: {
    fontSize: "13px",
    color: "#999",
    marginBottom: "10px",
  },
  mediaGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
    gap: "12px",
    marginTop: "10px",
  },
  mediaItem: {
    border: "1px solid #ccc",
    borderRadius: "4px",
    overflow: "hidden",
  },
  media: {
    width: "100%",
    height: "140px",
    objectFit: "cover",
  },
};

export default MySubmissions;
